/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import moment from 'moment';

export default class NextDepositDate extends Component {
  @action
  setNewDate(value) {
    this.newDate = value;
  }

  @service
  finance;

  @service
  toaster;

  @tracked loading = true;
  @tracked isManualUpdate = false;

  @computed('finance.nextDepositDate', 'loading', 'today', 'isManualUpdate')
  get dialogOpen() {
    if (this.isManualUpdate) {
      // Always show if the user manually triggered the update.
      // It's up to the caller to remove the component when done, by passing
      // an onClose action.
      return true;
    }
    if (this.loading) {
      // If we're still loading, don't show the dialog.
      return false;
    }

    // We've finished loading, so need to check the next deposit date.
    let nextDepositDate = this.get('finance.nextDepositDate');
    if (isEmpty(nextDepositDate)) {
      // No next deposit date has been set - prompt for one.
      return true;
    }

    // We have a non-empty value.  Prompt the user if it's in the past.
    return nextDepositDate < this.today;
  }

  @tracked today = moment().format('YYYY-MM-DD');
  newDate = '';

  didInsertElement() {
    super.didInsertElement(...arguments);
    this.finance.updateNextDepositDate().then(() => (this.loading = false));
  }

  // onClose allows an action to be passed in to be performed on closing of
  // the dialog box.  This should only be provided for manual updates.
  onClose() {}

  @action
  setNextDepositDate() {
    this.finance
      .setNextDepositDate(this.newDate)
      .then(() => {
        this.toaster.success('Next Deposit Date updated successfully.');
        if (this.isManualUpdate) {
          this.onClose();
        }
      })
      .catch(() => {
        this.toaster.error('Failed to update Next Deposit Date!');
      });
  }

  @action
  close() {
    this.onClose();
  }
}
